export default __webpack_public_path__ + "static/media/bg-nft@2x.c05aca09.png";